import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PlanEditService } from '../services/plan-edit.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
    providedIn: "root"
})
export class ResponseInterceptor implements HttpInterceptor {

    constructor(private planEditService: PlanEditService, private snackBar: MatSnackBar) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(map((event: HttpEvent<any>) => {
            return event;
        }), catchError(err => {
            if ([401, 403].includes(err.status)) {
                    this.planEditService.clear();
                    const config: MatSnackBarConfig = {
                    panelClass: ['snackbar-error'],
                    duration: 10000,
                    horizontalPosition: 'center',
                    verticalPosition: 'top'
                };
                this.snackBar.open('Something went wrong. Please refresh the page and try again. If the issue continues, contact an LSA administrator for assistance.', 'Dismiss', config);
            }

            const error = err.error?.message || err.statusText;
            console.error(error);
            return throwError(() => error);
        }));
    }
}
